import {Link} from "react-router-dom";
import {useContext, useEffect, useState} from "react";
import {UserContext} from "./UserContext";

export default function Header() {
  const {setUserInfo,userInfo} = useContext(UserContext);
  const {category, setCategory} = useState();
  const {data, setData} = useState([]);
  useEffect(() => {
    fetch('https://minggatu.zyberapi.site/profile', {
      credentials: 'include',
    }).then(response => {
      response.json().then(userInfo => {
        setUserInfo(userInfo);
      });
    });
    // fetch(`https://minggatu.zyberapi.site/profile?category=${category}`, {
    //   method: 'GET',
    //   credentials: 'include',
    // }).then(response => {
    //   response.json().then(userInfo => {
    //     setData(userInfo);
    //   });
    // });
  }, [category]);

  function logout() {
    fetch('https://minggatu.zyberapi.site/logout', {
      credentials: 'include',
      method: 'POST',
    });
    setUserInfo(null);
  }

  const username = userInfo?.username;

  return (
    <header>
      {/* <button>Tech</button> */}
      <Link to="/" className="logo">MyBlog</Link>
      <nav>
        <select value={category} onChange={(e) => setCategory(e.target.value)}>
          <option value="tech">tech</option>
        </select>
        
        {username && (
          <>
            <Link to="/create">Create new post</Link>
            <a onClick={logout}>Logout ({username})</a>
          </>
        )}
        {!username && (
          <>
            <Link to="/login">Login</Link>
            {/* <Link to="/register">Register</Link> */}
          </>
        )}
      </nav>
    </header>
  );
}
